import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppModel } from '../models/AppModel';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  apiGatewayUrl: string;

  constructor(private http: HttpClient) {
    this.apiGatewayUrl = environment().apiGatewayUrl;
  }

  getApp(): Observable<AppModel> {
    return this.http.get<AppModel>(`${this.apiGatewayUrl}app`);
  }
}
